import { render, staticRenderFns } from "./PrivacyConsentDialog.vue?vue&type=template&id=3261986d"
import script from "./PrivacyConsentDialog.vue?vue&type=script&lang=js"
export * from "./PrivacyConsentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports